import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';

import CollapseIcon from '../../../../assets/icons/double-chevron.svg';
import styles from './StoriesSection.module.scss';

export const StoriesSection = ({ title, items, renderItem }) => {
	const [isOpen, setIsOpen] = useState(false);
	const ref = useRef(null);

	return (
		<section
			ref={ref}
			className={cx(styles.section, {
				[styles.isOpen]: isOpen,
			})}>
			<div className={styles.content}>
				<h3>{title}</h3>
				<div className={styles.list}>{items.map(renderItem)}</div>
			</div>
			<button
				className={styles.collapseButton}
				onClick={() => {
					const element = ref.current;
					if (isOpen && element) {
						element.scrollIntoView();
					}
					setIsOpen(!isOpen);
				}}>
				<CollapseIcon />
			</button>
		</section>
	);
};

StoriesSection.propTypes = {
	title: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
	renderItem: PropTypes.func.isRequired,
};
